import { Title, Text } from "@mantine/core";
// import content from "../../../utils/report.json";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";
import { useTranslation } from "react-i18next";

const COLORS = ["#05D8D2", "#A64DD7", "#6F40E2", "#3A8BD9"];

type MergedRolesArray = {
  title: string;
  description: string;
};

const CloudOfProfessionsPDF: React.FC = () => {
  const { report } = useReportStore();

  const roles: MergedRolesArray[] = [];

  if (report.optimal_positions) {
    report.optimal_positions.data.forEach((role) => {
      roles.push({
        title: role.title,
        description: role.description,
      });
    });
  }

  if (report.higher_positions) {
    report.higher_positions.data.forEach((role) => {
      roles.push({
        title: role.title,
        description: role.description,
      });
    });
  }

  if (report.optimal_positions_switch) {
    report.optimal_positions_switch.data.forEach((role) => {
      roles.push({
        title: role.title,
        description: role.description,
      });
    });
  }

  if (report.unexpected_roles) {
    report.unexpected_roles.data.forEach((role) => {
      roles.push({
        title: role.title,
        description: role.description,
      });
    });
  }

  const careerPaths = roles.slice(0, 12);
  const { t } = useTranslation();
  return (
    <PDFPage padding>
      <Title size={36} mb={8}>
        {t("learn_about_professions")}
      </Title>
      <div className="career-map-container-pdf">
        <div className="career-paths-pdf">
          {careerPaths.map((career, index) => {
            return (
              <div
                key={index}
                className="career-path-pdf"
                style={{
                  backgroundColor: COLORS[index % COLORS.length],
                }}
              >
                <div className="career-path-icon-pdf" />
                <Text size="lg" className="career-title-pdf">
                  {career.title}
                </Text>
                <Text size="md" className="career-info-pdf">
                  <strong> {t("career.description")}:</strong>{" "}
                  {career.description}
                </Text>
              </div>
            );
          })}
        </div>
      </div>
    </PDFPage>
  );
};

export default CloudOfProfessionsPDF;
